"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var vehicle_service_1 = require("../../service/vehicle.service");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var customer_service_1 = require("../../../shared/service/customer.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var diagnosis_service_1 = require("../../service/diagnosis.service");
var diagnosis_type_1 = require("../../../shared/model/diagnosis-type");
var VehicleSelectComponent = /** @class */ (function () {
    function VehicleSelectComponent(_router, _vehicleService, _customerService, _diagnosisNotification, _toastService, _diagnosisService) {
        this._router = _router;
        this._vehicleService = _vehicleService;
        this._customerService = _customerService;
        this._diagnosisNotification = _diagnosisNotification;
        this._toastService = _toastService;
        this._diagnosisService = _diagnosisService;
        this.customerAttributesTree = ['name'];
        this.disablePlateInput = true;
        this.disableCustomersInput = true;
        this.loadingOrgLabel = 'Selecione primeiro um Cliente';
        this.loadingCustomerLabel = 'Selecione primeiro um Tipo';
        this.modalActions = new core_1.EventEmitter();
    }
    VehicleSelectComponent.prototype.ngOnInit = function () {
        this.setUpEmptyEntities();
        this.setUpVehiclesObserver();
        this.setUpCustomersObserver();
        this.getDiagnosticsTypes();
    };
    VehicleSelectComponent.prototype.startDiagnosis = function () {
        if (this.selectedVehicle && this.diagnosticType) {
            var vehi = this.selectedVehicle;
            vehi.diagnosisType = this.diagnosticType;
            this.selectedVehicle = vehi;
            this.run();
        }
        else if (!this.selectedVehicle) {
            this._toastService.showMessage('Selecione uma placa!', 4000);
        }
        else if (!this.diagnosticType) {
            this._toastService.showMessage('Selecione um Tipo de Diagnóstico!', 4000);
        }
    };
    VehicleSelectComponent.prototype.getVehicles = function (customer) {
        this._customer = customer;
        this._diagnosisNotification.setCustomer(customer);
        this._vehicleService.getVehiclesByUser(customer.trixUser.id, this.diagnosticType);
        this.loadingOrgLabel = 'Carregando...';
    };
    VehicleSelectComponent.prototype.getCustomersBasedOn = function (name) {
        this._customerService.getCustomersBasedOn(name);
    };
    VehicleSelectComponent.prototype.selectVehicle = function (vehicle) {
        vehicle.diagnosisType = this.diagnosticType;
        this.selectedVehicle = vehicle;
    };
    VehicleSelectComponent.prototype.setDiagnosticType = function (diagnosticType) {
        this.diagnosticType = diagnosticType;
        this.disableCustomersInput = false;
        if (this._customer) {
            this.getVehicles(this._customer);
        }
    };
    VehicleSelectComponent.prototype.setUpEmptyEntities = function () {
        this.customers = new Array();
        this.vehicles = new Array();
        this.diagnosticsTypes = new Array();
    };
    VehicleSelectComponent.prototype.setUpVehiclesObserver = function () {
        var _this = this;
        this._vehicleService.find$
            .subscribe(function (vehicles) {
            _this.vehicles = vehicles;
            _this.disablePlateInput = false;
        });
    };
    VehicleSelectComponent.prototype.setUpCustomersObserver = function () {
        var _this = this;
        this._customerService.find$
            .filter(function (data) { return data instanceof Array; })
            .subscribe(function (customers) { return _this.customers = customers; });
    };
    VehicleSelectComponent.prototype.getDiagnosticsTypes = function () {
        var _this = this;
        this._diagnosisService.getDiagnosisticsTypes()
            .subscribe(function (response) {
            _this.diagnosticsTypes = Object.assign(new Array(), JSON.parse(response._body));
        }, function (error) { return _this.diagnosticsTypes = undefined; });
    };
    VehicleSelectComponent.prototype.run = function () {
        if (this.selectedVehicle.diagnosisType == diagnosis_type_1.DiagnosisType.GENERAL) {
            this.goToDiagnosisComponent();
        }
        else if (this.selectedVehicle.diagnosisType == diagnosis_type_1.DiagnosisType.SIMPLIFIED) {
            this.modalActions.emit({ action: 'modal', params: ['open'] });
        }
    };
    VehicleSelectComponent.prototype.goToDiagnosisComponent = function () {
        this._router.navigate(['diagnosis/run', { data: JSON.stringify({ vehicle: this.selectedVehicle, vehicles: this.vehicles, showTitle: true }) }]);
    };
    VehicleSelectComponent.ctorParameters = function () { return [{ type: router_1.Router }, { type: vehicle_service_1.VehicleService }, { type: customer_service_1.CustomerService }, { type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: toast_service_1.ToastService }, { type: diagnosis_service_1.DiagnosisService }]; };
    return VehicleSelectComponent;
}());
exports.VehicleSelectComponent = VehicleSelectComponent;
//# sourceMappingURL=vehicle-select.component.js.map


// WEBPACK FOOTER //
// vehicle-select.component.js